import { Component, Input } from '@angular/core';
import { Company } from '../../../lib/interfaces/company';
import { serverurl } from '../../../../environments/environment';
import { SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-company-logo',
    standalone: false,
    templateUrl: './company-logo.component.html',
    styleUrl: './company-logo.component.scss'
})
export class CompanyLogoComponent {
    @Input({ required: true }) public company!: Company;
    @Input() base64!: SafeUrl;

    protected serverurl = serverurl;
}

